import { LayoutGrid, DollarSign } from 'lucide-react'
import type { ViewMode } from '../../types'

interface ViewToggleProps {
  viewMode: ViewMode
  onChange: (mode: ViewMode) => void
}

export function ViewToggle({ viewMode, onChange }: ViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg p-0.5 bg-fn-muted">
      <button
        type="button"
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${viewMode === 'flow' ? 'bg-fn-primary text-fn-primary-text' : 'text-fn-text-sub'}`}
        onClick={() => onChange('flow')}
      >
        <LayoutGrid className="w-4 h-4" />
        Flow
      </button>
      <button
        type="button"
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${viewMode === 'pricing' ? 'bg-fn-primary text-fn-primary-text' : 'text-fn-text-sub'}`}
        onClick={() => onChange('pricing')}
      >
        <DollarSign className="w-4 h-4" />
        Pricing
      </button>
    </div>
  )
}
